import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserAlertsServicesFactory} from '../../userAlerts/Services/factory'
import NotificationsServicesFactory from '../Services/factory'
import {GetUnreadMessagesService} from '../Services/GetUnreadMessagesService.js'

class GetAllMessagingNotificationsUseCase extends UseCase {
  #config
  #getPendingPtaService
  #getUnreadMessagesService
  #getUnseenSavedSearchMatchesService

  constructor({config, getPendingPtaService, getUnreadMessagesService, getUnseenSavedSearchMatchesService}) {
    super()
    this.#config = config
    this.#getPendingPtaService = getPendingPtaService
    this.#getUnreadMessagesService = getUnreadMessagesService
    this.#getUnseenSavedSearchMatchesService = getUnseenSavedSearchMatchesService
  }

  static create({config}) {
    return new GetAllMessagingNotificationsUseCase({
      config,
      getPendingPtaService: NotificationsServicesFactory.getPendingPtaService({
        config
      }),
      getUnreadMessagesService: GetUnreadMessagesService.create({config}),
      getUnseenSavedSearchMatchesService: UserAlertsServicesFactory.getUnseenSavedSearchMatchesService({
        config
      })
    })
  }

  @tracer({metric: 'GetAllMessagingNotificationsUseCase#execute'})
  async execute() {
    const [pendingPtaVO, unreadMessagesVO, unseenSavedSearchesVO] = await Promise.all([
      this.#getPendingPtaService.execute(),
      this.#getUnreadMessagesService.execute(),
      this.#getUnseenSavedSearchMatchesService.execute()
    ])

    return {
      pendingPta: pendingPtaVO.toJSON().pendingPta,
      unreadMessages: unreadMessagesVO.toJSON().unreadMessages,
      unseenSavedSearches: unseenSavedSearchesVO.toJSON().matchCounters
    }
  }
}

export const factory = GetAllMessagingNotificationsUseCase.create
